<template>
	<CRow>
		<CCol sm="12">
			<CButton @click="collapse=!collapse" color="primary" class="mb-2">
				فیلتر داده‌ها
			</CButton>
			<CCollapse :show="collapse" :duration="400">
				<CCard>
					<CCardHeader>
						<strong>گزینه‌های فیلتر</strong>
					</CCardHeader>
					<CCardBody>
						<CRow>
                            <CCol sm="3">
                                <label>کاربر</label>
                                <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                </model-select>
                                <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                            </CCol>
                            <CCol sm="3">
                                <CInput v-model="form.to_num.val" :description="form.to_num.inv" label="به شماره" dir="ltr" />
                            </CCol> 
						</CRow>
						<br>
						<div class="form-group form-actions">
							<CButton @click="validator();filter=true;page=1;get()" class="ml" color="primary">فیلتر</CButton>
							<CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
						</div>
					</CCardBody>
				</CCard>
			</CCollapse>
		</CCol>
		<CCol col="12" xl="12">
			<CCard>
				<CCardHeader>
					<strong>گیرنده‌ها</strong> 
					<div class="card-header-actions">
						تعداد: {{row_count}}
					</div>
				</CCardHeader>
				<CCardBody>
					<CCol sm="5">
						<CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
						{value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count"
						placeholder="تعداد سطرها" @change="limit=$event.target.value" />
					</CCol>
					<CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                        <template #action="data">
                            <td>
                                <template>
                                    <div class="flex-container">
                                        <div v-show="$store.state.perms.can_delete_out_box_gradual_sms_rcv_numbers
                                            || $store.state.perms.can_delete_out_box_gradual_sms_rcv_numbers_for_same_group_users
                                            || $store.state.perms.can_delete_out_box_gradual_sms_rcv_numbers_for_all_users"
                                            @click="delete_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'حذف'">
                                            <CIcon name="cilTrash" size="lg"/>
                                        </div>
                                    </div>
                                </template>
                            </td>
                        </template>
          		</CDataTable>
				<br>
				<div> 
					<CPagination
					:activePage.sync="page"
					:pages="page_count"
					align="center"
					:doubleArrows="true"
					/>
				</div>
			</CCardBody>
		</CCard>
		</CCol>
		<CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
  </CRow>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
	data() {
		return {
			row_count: '',
			items: [],
			fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'user_name', label: 'کاربر' },
                { key: 'to_num', label: 'به شماره' },
                { key: 'action', label: 'عملیات' },
			],
			collapse: false,
			form: {
				user_id: {val: '', inv: '', v: {max: 8}},
				to_num: {val: '', inv: '', v: {max: 1024}},
			},
			disable: false,
			page: 1,
			page_count: 0,
			offset: 0,
			limit: 10,
			delete_modal: false,
            id: 0,
			users:[],
		}
	},
	watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
	mounted() {
		this.get();
		this.get_users();
	},
	methods: {
		get() {
			if(this.disable == false){
				let filter = '';
				for (const key in this.form) {
					if(this.form[key].val != ''){
						filter += `&${key}=` + this.form[key].val;
					}
				}
				this.axios.get('out_box_gradual_sms_rcv_numbers/'
					+ '?count=1'
					+ '&gradual_sms_group_id=' + this.$route.params.id
					+ filter)
					.then(res => {
						this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
						this.offset = 0;
						if(this.page != 1){
							this.offset = (this.page * this.limit) - this.limit;
						}
					})
				.finally(() => {
					this.axios.get('out_box_gradual_sms_rcv_numbers/'
						+ '?limit=' + this.limit
						+ '&offset=' + this.offset
						+ '&gradual_sms_group_id=' + this.$route.params.id
						+ '&user_info=1' 
						+ '&out_box_gradual_sms_group_info=1'
						+ filter)
						.then(res => {
							res.data.map(val =>{
								val.gradual_sms_group_name = val.out_box_gradual_sms_group_info.name;
								val.user_name = `${val.user_info.first_name} ${val.user_info.last_name}`;
							});
							this.items = res.data;
						})
				})
			}
		},
		delete_row() {
			this.axios.delete('out_box_gradual_sms_rcv_numbers/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
				});
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
				});
				this.delete_modal = false;
			})
		},
		remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
		redirect_to(route) {
			this.$router.push(route);
		},
		get_users(){
            this.axios.get('users/?type=view_out_box_gradual_sms_send_sequences')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
	},
	beforeCreate(){
		if(this.$store.state.perms.can_view_out_box_gradual_sms_rcv_number_page == false
			&& this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>